import { render, staticRenderFns } from "./AddNewMarginCostPopUp.vue?vue&type=template&id=5bd785f9&scoped=true&"
import script from "./AddNewMarginCostPopUp.vue?vue&type=script&lang=js&"
export * from "./AddNewMarginCostPopUp.vue?vue&type=script&lang=js&"
import style0 from "./AddNewMarginCostPopUp.vue?vue&type=style&index=0&id=5bd785f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd785f9",
  null
  
)

export default component.exports